export default __webpack_public_path__ + "static/media/color-fan.7bbef974.webp";